export default "__VITE_ASSET__3bae5b70__"